import { useCallback } from "react";

/**
 * Write-path arena id: returns a getter that throws if the arena is missing.
 *
 * Read-path hooks take `arenaId?: number` and skip their query until it
 * resolves. Writes can't do that — they fire on user action, well after the
 * arena has resolved, so an absent id is a programming error we surface loudly
 * rather than send to fay as NaN. Every write hook routes through here so that
 * guard has one definition instead of one per hook.
 */
export function useRequiredArenaId(arenaId: number | undefined): () => number {
  return useCallback(() => {
    if (arenaId === undefined) {
      throw new Error("Arena is not available");
    }
    return arenaId;
  }, [arenaId]);
}
